export default __webpack_public_path__ + "static/media/8_Still.c5fbf620.jpg";